<sz-app-shell>
  <sz-top-bar />

  @if (session(); as s) {
    <div class="summary">
      <sz-page-title [title]="titleMain()" [accent]="titleAccent()" [showBack]="!completed" size="xl">
        <div szTitleKicker class="summary__kicker">
          <span class="summary__kicker-status">{{ 'session.summary.kickerStatus' | translate }}</span>
          <span class="summary__sep">·</span>
          <span>{{ endedAtKicker() }}</span>
        </div>
        <div szTitleSub class="summary__sub">
          <sz-num-big [value]="durationMinutes()" [unit]="'session.summary.minutesUnit' | translate" />
          <sz-num-big [value]="totalRunsLabel()" [unit]="'session.summary.runsUnit' | translate" />
          <sz-num-big [value]="drillCountLabel()" [unit]="'session.summary.drillsUnit' | translate" />
        </div>
      </sz-page-title>

      <sz-section-head [label]="'session.summary.perDrillLabel' | translate" />
      <div class="summary__per-drill">
        @for (row of perDrillRows(); track row.id) {
          <div class="summary__drill" [class.summary__drill--open]="isExpanded(row.id)">
            <sz-row-card
              variant="flat"
              class="summary__drill-head"
              role="button"
              tabindex="0"
              [interactive]="true"
              [attr.aria-expanded]="isExpanded(row.id)"
              [attr.aria-label]="'session.summary.expandRunsAria' | translate: { drill: row.drillName }"
              (click)="toggleDrill(row.id)"
              (keydown.enter)="toggleDrill(row.id)"
              (keydown.space)="toggleDrill(row.id)">
              <sz-ic-circle szRowLead size="sm" accent="ghost">
                {{ row.scoringShort }}
              </sz-ic-circle>
              <div class="summary__per-drill-body">
                <div class="summary__per-drill-name">{{ row.drillName }}</div>
                <div class="summary__per-drill-meta">
                  {{ 'session.summary.runsCount' | translate: { count: row.runsCount } }}
                </div>
              </div>
              <div szRowEnd class="summary__per-drill-end">
                <div class="summary__per-drill-best">
                  <div class="summary__per-drill-best-value">{{ row.bestValue }}</div>
                  @if (row.showBestLabel) {
                    <div class="summary__per-drill-best-label">{{ 'session.summary.bestLabel' | translate }}</div>
                  }
                </div>
                <span class="summary__chevron">
                  <sz-icon name="chevron-right" [size]="14" />
                </span>
              </div>
            </sz-row-card>

            @if (isExpanded(row.id)) {
              <div class="summary__runs">
                @if (row.runRows.length > 0) {
                  <lib-session-rep-list [rows]="row.runRows" [interactive]="false" />
                } @else {
                  <p class="summary__runs-empty">{{ 'session.summary.noRuns' | translate }}</p>
                }
              </div>
            }
          </div>
        }
      </div>

      @if (s.plan; as p) {
        <sz-card variant="subtle">
          <div class="summary__plan-row">
            <div class="summary__plan-body">
              <div class="summary__plan-label">{{ 'session.summary.planLabel' | translate }}</div>
              <div class="summary__plan-title">
                {{ p.title ?? ('session.summary.planUntitled' | translate) }}
                <span class="summary__plan-status">· {{ 'session.summary.planCompleted' | translate }}</span>
              </div>
            </div>
          </div>
        </sz-card>
      }

      <sz-partner-card
        variant="feed"
        [logoFull]="true"
        [clickable]="true"
        [linkCta]="true"
        [logoSrc]="partnerLogo"
        [logoAlt]="partnerName"
        [accent]="partnerAccent"
        [ctaLabel]="'partners.feedCta' | translate"
        (action)="openPartner()" />
    </div>

    @if (completed) {
      <sz-cta-bar variant="floating">
        <sz-button variant="primary" [fullWidth]="true" (click)="done()">
          {{ 'session.summary.doneCta' | translate }}
        </sz-button>
      </sz-cta-bar>
    }
  } @else {
    <div class="summary__skeleton">
      <sz-skeleton shape="text" width="40%" height="12px" />
      <sz-skeleton shape="text" width="60%" height="34px" />
      <sz-skeleton shape="text" width="50%" height="20px" />
      <sz-skeleton shape="block" height="64px" />
      <sz-skeleton shape="block" height="64px" />
    </div>
  }
</sz-app-shell>

<lib-rating-prompt-sheet />
